
export default ({ isOnline }) => {
  const userStatus = isOnline ? "online" : "offline";
  return <div className={`user-status ${userStatus}`}></div>;
};
